import { render } from "./itemList_coin.vue?vue&type=template&id=ca2e6efc"
import script from "./itemList_coin.vue?vue&type=script&lang=js"
export * from "./itemList_coin.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__